import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDq9HHy1dFKmz0HwZ5TWIaY0PgGzvOmpMQ",
  authDomain: "siteamirhossein-259bc-5c006.firebaseapp.com",
  projectId: "siteamirhossein-259bc",
  storageBucket: "siteamirhossein-259bc.appspot.com",
  messagingSenderId: "532153874968",
  appId: "1:532153874968:web:0c89037784441e69e9a16d",
  measurementId: "G-M3D8H4PWJ7",
};

const app = initializeApp(firebaseConfig)

const db = getFirestore()

export { db }
export const auth = getAuth(app);